import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {
    devConfig, // Importing development configuration
    gamesCasino, // Importing casino games configuration
    profile, // Importing user profile configuration
    providersCasino, // Importing casino providers configuration
} from 'config/config'; // Importing configuration from config file

/**
 * Class representing the view for machine products.
 */
export default class tableMachineProductsView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The layout configuration.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        const cur_user = this.getParam('user', true); // Get current user parameter
        var data = []; // Initialize data array
        return {
            rows: [
                {
                    view: 'dataview', // Data view component
                    id: 'dataview1', // Unique identifier for the data view
                    css: 'myBackground', // CSS class for styling
                    template: function (obj) {
                        // Template function for rendering items
                        var width = 200 * parseInt(obj.column); // Calculate width based on column
                        var height = 120 * parseInt(obj.row); // Calculate height based on row
                        return (
                            `<div class="container w-` +
                            obj.column +
                            ` h-` +
                            obj.row +
                            `">
                               <img src="` +
                            obj.icon +
                            `"  width="` +
                            width +
                            `" height="` +
                            height +
                            `">
                              <div class="top-left">` +
                            obj.name +
                            `</div>
                             </div>`
                        ); // Return HTML structure for each item
                    },
                    scroll: 'y', // Enable vertical scrolling
                    autoheight: false, // Disable automatic height adjustment
                    drag: true, // Enable dragging of items
                    type: {
                        width: 'auto', // Set width type
                        height: 'auto', // Set height type
                        css: 'myDataview', // CSS class for dataview
                    },
                    // API endpoint for loading data
                    url: devConfig.geturlApi() + 'MachineGames/GetOrderMachineGames?IdMachine=' + cur_user + '&',
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        const cur_user = this.getParam('user', true); // Get current user parameter
        var categorie = ''; // Initialize category variable
        this.on(this.app, 'machineProducts:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Categorie') {
                        categorie = object[i][1]; // Set category from filter
                    }
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object values
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through nested object entries
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            $$('dataview1').clearAll(); // Clear existing data in dataview
            $$('dataview1').load(
                // Load new data into dataview
                devConfig.geturlApi() + 'MachineGames/GetOrderMachineGames?IdMachine=' + cur_user + string1,
            );
        });
        $$('dataview1').attachEvent('onBeforeDrop', function (context, ev) {
            // Event for before drop action
            webix.delay(
                // Delay execution of the following function
                function () {
                    var orderMachineGames = context.from.data.order; // Get order from context
                    console.log(orderMachineGames); // Log order
                    webix
                        .ajax() // AJAX request to save order
                        .headers({
                            'Content-type': 'application/json', // Set content type
                        })
                        .post(
                            devConfig.geturlApi() + 'MachineGames/SaveOrderMachineGames',
                            '{"IdMachine":"' +
                                cur_user +
                                '","OrderMachineGames":"' +
                                orderMachineGames +
                                '", "Categorie":"' +
                                categorie +
                                '"}', // Send order data
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    // Error callback
                                    webix.message(_('Error! ')); // Show error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    // Success callback
                                    var data = JSON.parse(text); // Parse response data
                                    if (!data.HasError) {
                                        webix.message(_('Juego Ordenado')); // Show success message
                                    } else {
                                        webix.message(_('Error! ')); // Show error message
                                    }
                                },
                            },
                        );
                },
                '',
                '',
                1000, // Delay duration
            );
        });
    }
}

// FILE DOCUMENTED
